import { Input, ItandiChip } from "@itandi/itandi-bb-ui";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type { SubtypeEdit } from "~/models/Subtype";
import Styles from "./SubtypeModalForm.module.scss";

export const SubtypeModalForm: React.FC = () => {
	const {
		formState: { errors },
		register
	} = useFormContext<SubtypeEdit>();
	return (
		<div className={Styles.Forms}>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					案件タイプ名
					<span className={Styles.RequiredLabel}>
						<ItandiChip label="必須" />
					</span>
				</div>
				<div className={Styles.FormSettingCol}>
					<Input
						isInvalid={!!errors.name}
						placeholder="例）原状回復"
						{...register("name")}
					/>
					{errors.name ? (
						<div className={Styles.InvalidFeedback}>{errors.name.message}</div>
					) : null}
				</div>
			</div>
			<div className={Styles.FormRow}>
				<div className={Styles.FormLabelCol}>
					取り込みキー
					<span className={Styles.RequiredLabel}>
						<ItandiChip label="任意" />
					</span>
				</div>
				<div className={Styles.FormSettingCol}>
					<Input
						isInvalid={!!errors.foreignKey}
						placeholder="例）restoration"
						{...register("foreignKey")}
					/>
					{errors.foreignKey ? (
						<div className={Styles.InvalidFeedback}>
							{errors.foreignKey.message}
						</div>
					) : null}
				</div>
			</div>
		</div>
	);
};
